// @flow

import { EventEmitter } from 'fbemitter';

export class Megaphone {
    emitter: EventEmitter;

    static getInstance() {
        return megaphone.emitter;
    }

    static addListener(...args: any) {
        return megaphone.emitter.addListener(...args);
    }

    static emit(...args: any) {
        return megaphone.emitter.emit(...args);
    }

    constructor() {
        this.emitter = new EventEmitter();
    }
}

const megaphone: Megaphone = new Megaphone();



// WEBPACK FOOTER //
// ./src/v5/home/lib/Megaphone.js